// 환경별 설정 관리
const config = {
  // 환경 정보
  env: process.env.REACT_APP_ENV || 'development',
  
  // API URL
  apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:3000',
  
  // 기본 URL (라우팅용)
  baseUrl: process.env.REACT_APP_BASE_URL || '',
  
  // 공개 URL (정적 파일용)
  publicUrl: process.env.PUBLIC_URL || '',
  
  // 환경별 설정
  isDevelopment: process.env.REACT_APP_ENV === 'development',
  isProduction: process.env.REACT_APP_ENV === 'production',
  
  // 기능 플래그
  features: {
    // 개발 환경에서만 활성화할 기능들
    debugMode: process.env.REACT_APP_ENV === 'development',
    analytics: process.env.REACT_APP_ENV === 'production',
  }
};

export default config;
